import { JsonServiceClient } from '@servicestack/client';
import { router } from '../index';
import { handleAuthenticationResponse, handleAuthenticationException } from '../helpers/authenticationBridge';

const jsonServiceClient = new JsonServiceClient('/');
jsonServiceClient.responseFilter = handleAuthenticationResponse;
jsonServiceClient.exceptionFilter = (response: Response) => {
    handleAuthenticationException(response, (path, options) => router.navigate(path, options));
};

export var client = jsonServiceClient;
